module.exports = __webpack_public_path__ + "static/media/Ackee-Logo.4182a6fc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Ackee-Logo.png
 ** module id = 763
 ** module chunks = 0
 **/